export const resolveSelectionNameToDisplay = (selectionName: string, lineLabel: string | undefined): string => {
    return lineLabel !== undefined && /[+-]\d+(?:\.\d+)?\)?\s*$/.test(selectionName) === false
        ? `${selectionName} ${lineLabel}`
        : selectionName;
};
